import CloseIcon from "../../../../../assets/icons/CloseIcon"
import { fnDecodeStorageToken } from "../../../../../utils/encodeLocalStorage"
import { usePlanContext } from "../../context"
import styles from "./index.module.scss"
import React, { useMemo } from "react"

const currencyFormatter = (() => {
  const cLocale = fnDecodeStorageToken()?.cLocale ?? "pt-br"
  const oNumberFormatter = new Intl.NumberFormat(cLocale, {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  })
  return oNumberFormatter
})()

function PriceLabel({ nValue = 0, cTimeUnit = "", cDiscount = "" }) {
  const cFormattedValue = useMemo(() => currencyFormatter.format(nValue / 100), [nValue])
  return (
    <div className={`${styles.cardRow} ${styles.priceContainer}`}>
      <span className={styles.priceValue}>{cFormattedValue}</span>
      <span className={styles.pricePeriod}> / {cTimeUnit}</span>{" "}
      {cDiscount && (
        <span className={styles.discountLabel}>{cDiscount}% de desconto</span>
      )}
    </div>
  )
}

export default function PlanCard() {
  const { nPriceMonth, nPriceYear, oVoucher, oSystemConfig, clearVoucher } =
    usePlanContext()
  const cVoucherCode = oVoucher.vch_ccode
  const cAnnualDiscount = oSystemConfig.discount_annual_plan
    ? oSystemConfig.discount_annual_plan
    : ""
  return (
    <div className={styles.cardContainer}>
      <p className={`${styles.cardRow} ${styles.alignLeft}`}>
        <span className={`${styles.cardTitle}`}>Investimento: </span>
        {cVoucherCode && (
          <span className={styles.voucherLabel}>
            {cVoucherCode}
            <CloseIcon
              fill={"#6cb6e3"}
              style={{ marginLeft: 5, cursor: "pointer", height: "1rem" }}
              onClick={() => clearVoucher()}
            />
          </span>
        )}
      </p>
      <PriceLabel nValue={nPriceMonth} cTimeUnit="mês" />
      <p className={`${styles.cardRow} ${styles.alignLeft}`}>ou</p>
      <PriceLabel nValue={nPriceYear} cTimeUnit="ano" cDiscount={cAnnualDiscount} />
    </div>
  )
}
